import React from 'react';
import Icon from './../components/Icon';
import { Flex, Box } from './../components/layout/Grid';

const TextWithIcon = props => (
  <Flex
    mx="-5px"
    alignItems="center"
    justifyContent={props.rightSideIcon ? 'space-between' : 'normal'}
    style={{ width: props.rightSideIcon ? '100%' : 'auto' }}
    className={props.className}
  >
    {props.rightSideIcon ? null : (
      <Box mx="5px">
        <Icon
          name={props.icon}
          color={props.iconColor}
          fontSize={props.iconSize}
          style={{ verticalAlign: 'middle' }}
        />
      </Box>
    )}
    <Box
      as="p"
      mx="5px"
      style={{ textTransform: props.uppercase ? 'uppercase' : 'inherit' }}
    >
      {props.children}
    </Box>
    {props.rightSideIcon ? (
      <Box mx="5px">
        <Icon
          name={props.icon}
          color={props.iconColor}
          fontSize={props.iconSize}
        />
      </Box>
    ) : null}
  </Flex>
);

export default TextWithIcon;
